import React from 'react';

export const Separator = () => {
  return (
    <svg width="25" height="43" viewBox="0 0 25 43" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="0.433013" y1="0.75" x2="24.433" y2="42.3192" stroke="url(#paint0_linear_466_1075)"/>
      <defs>
        <linearGradient id="paint0_linear_466_1075" x1="24" y1="42.5692" x2="2.3625" y2="5.09197" gradientUnits="userSpaceOnUse">
          <stop stopColor="#10193C"/>
          <stop offset="0.489583" stopColor="white"/>
          <stop offset="1" stopColor="#10193D"/>
        </linearGradient>
      </defs>
    </svg>

  );
}
